// extracted by mini-css-extract-plugin
export default {"wrap":"TI-z","articleImagesWrap":"UI-z","articleImage":"VI-z","singleImage":"WI-z"};